import { useState } from "react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogFooter,
	DialogHeader,
	DialogTitle,
} from "@/components/ui/dialog";
import { Spinner } from "@/components/ui/spinner";

export function BlankChatPane() {
	return <div data-slot="blank-chat-pane" className="h-full bg-background" />;
}

export function ThreadImpersonationPrompt({
	currentUserEmail,
	ownerEmail,
	onSwitch,
	switching = false,
	error,
}: {
	currentUserEmail: string;
	ownerEmail: string;
	onSwitch: () => void;
	switching?: boolean;
	error?: string;
}) {
	const [dismissed, setDismissed] = useState(false);

	return (
		<>
			<BlankChatPane />
			<Dialog
				open={!dismissed}
				onOpenChange={(open) => {
					if (!open && !switching) setDismissed(true);
				}}
			>
				<DialogContent showCloseButton={false} className="sm:max-w-md">
					<DialogHeader>
						<DialogTitle>Switch user to view this chat?</DialogTitle>
						<DialogDescription>
							Current user <strong>{currentUserEmail}</strong> does not own this
							thread. It belongs to <strong>{ownerEmail}</strong>. Switch
							impersonation to view it.
						</DialogDescription>
					</DialogHeader>
					{error ? (
						<Alert variant="destructive">
							<AlertTitle>Could not switch user</AlertTitle>
							<AlertDescription>{error}</AlertDescription>
						</Alert>
					) : null}
					<DialogFooter>
						<Button
							variant="outline"
							onClick={() => setDismissed(true)}
							disabled={switching}
						>
							Stay here
						</Button>
						<Button onClick={onSwitch} disabled={switching}>
							{switching ? <Spinner data-icon="inline-start" /> : null}
							{switching ? "Switching..." : "Switch user"}
						</Button>
					</DialogFooter>
				</DialogContent>
			</Dialog>
		</>
	);
}
